import { getEntityTemplateLang } from '~services/entity-definitions/helpers';
import { createTemporaryEntityId } from '~services/entity-definitions/template-helpers';

export default () => {
  const itemId1 = createTemporaryEntityId();
  const itemId2 = createTemporaryEntityId();
  const itemId3 = createTemporaryEntityId();
  const itemId4 = createTemporaryEntityId();
  const itemId5 = createTemporaryEntityId();
  const itemId6 = createTemporaryEntityId();
  return {
    data: {
      type: 'paragraph--moodboard',
      id: createTemporaryEntityId(),
      attributes: {
        langcode: getEntityTemplateLang(),
        status: true,
        default_langcode: true,
        field_hide_title: false,
        field_search_text: null,
        field_layout: 1,
        field_title: { value: 'I am a Moodboard Module', format: 'rich_text' },
        field_padding_top: null,
        field_padding_bottom: null,
      },
      relationships: {
        field_images: {
          data: [
            {
              type: 'paragraph--moodboard_image',
              id: itemId1,
            },
            {
              type: 'paragraph--moodboard_image',
              id: itemId2,
            },
            {
              type: 'paragraph--moodboard_image',
              id: itemId3,
            },
            {
              type: 'paragraph--moodboard_image',
              id: itemId4,
            },
            {
              type: 'paragraph--moodboard_image',
              id: itemId5,
            },
          ],
        },
        field_tags: {
          data: [],
        },
      },
      links: {},
      permissions: {
        update: true,
        create: true,
        delete: true,
      },
    },
    included: [
      {
        type: 'paragraph--moodboard_image',
        id: itemId1,
        attributes: {
          langcode: getEntityTemplateLang(),
          status: true,
          default_langcode: true,
          field_link_external: null,
          field_link_module: null,
          field_link_text: 'Lorem ipsum',
          field_search_text: null,
          field_title: { value: 'Lorem ipsum dolor', format: 'rich_text' },
        },
        relationships: {
          field_image: {},
          field_tags: {
            data: [],
          },
        },
        links: {},
        permissions: {
          update: true,
          create: true,
          delete: true,
        },
      },
      {
        type: 'paragraph--moodboard_image',
        id: itemId2,
        attributes: {
          langcode: getEntityTemplateLang(),
          status: true,
          default_langcode: true,
          field_link_external: null,
          field_link_module: null,
          field_link_text: '',
          field_search_text: null,
          field_title: { value: '', format: 'rich_text' },
        },
        relationships: {
          field_image: {},
          field_tags: {
            data: [],
          },
        },
        links: {},
        permissions: {
          update: true,
          create: true,
          delete: true,
        },
      },
      {
        type: 'paragraph--moodboard_image',
        id: itemId3,
        attributes: {
          langcode: getEntityTemplateLang(),
          status: true,
          default_langcode: true,
          field_link_external: null,
          field_link_module: null,
          field_link_text: '',
          field_search_text: null,
          field_title: { value: '', format: 'rich_text' },
        },
        relationships: {
          field_image: {},
          field_tags: {
            data: [],
          },
        },
        links: {},
        permissions: {
          update: true,
          create: true,
          delete: true,
        },
      },
      {
        type: 'paragraph--moodboard_image',
        id: itemId4,
        attributes: {
          langcode: getEntityTemplateLang(),
          status: true,
          default_langcode: true,
          field_link_external: null,
          field_link_module: null,
          field_link_text: '',
          field_search_text: null,
          field_title: { value: '', format: 'rich_text' },
        },
        relationships: {
          field_image: {},
          field_tags: {
            data: [],
          },
        },
        links: {},
        permissions: {
          update: true,
          create: true,
          delete: true,
        },
      },
      {
        type: 'paragraph--moodboard_image',
        id: itemId5,
        attributes: {
          langcode: getEntityTemplateLang(),
          status: true,
          default_langcode: true,
          field_link_external: null,
          field_link_module: null,
          field_link_text: '',
          field_search_text: null,
          field_title: { value: '', format: 'rich_text' },
        },
        relationships: {
          field_image: {},
          field_tags: {
            data: [],
          },
        },
        links: {},
        permissions: {
          update: true,
          create: true,
          delete: true,
        },
      },
      {
        type: 'paragraph--moodboard_image',
        id: itemId6,
        attributes: {
          langcode: getEntityTemplateLang(),
          status: true,
          default_langcode: true,
          field_link_external: null,
          field_link_module: null,
          field_link_text: '',
          field_search_text: null,
          field_title: { value: '', format: 'rich_text' },
        },
        relationships: {
          field_image: {},
          field_tags: {
            data: [],
          },
        },
        links: {},
        permissions: {
          update: true,
          create: true,
          delete: true,
        },
      },
    ],
  };
};
